import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-warehouse",
  "use": "icon-warehouse-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-warehouse\"><defs><style type=\"text/css\"></style></defs><path d=\"M755.2 291.2L544 169.6c-19.2-12.8-44.8-12.8-64 0L268.8 291.2c-16 9.6-19.2 28.8-12.8 44.8 3.2 6.4 6.4 9.6 12.8 12.8l227.2 134.4c9.6 6.4 22.4 6.4 32 0l227.2-134.4c16-9.6 19.2-28.8 12.8-44.8l-12.8-12.8z m28.8 102.4l-230.4 134.4c-9.6 6.4-16 16-16 28.8V832c0 19.2 12.8 32 32 32 6.4 0 9.6 0 16-3.2l230.4-134.4c9.6-6.4 16-16 16-28.8v-275.2c0-19.2-12.8-32-32-32-6.4 0-9.6 0-16 3.2zM192 422.4v275.2c0 12.8 6.4 22.4 16 28.8l230.4 134.4c16 9.6 35.2 3.2 41.6-12.8 3.2-6.4 3.2-9.6 3.2-16v-275.2c0-12.8-6.4-22.4-16-28.8l-230.4-134.4c-12.8-9.6-32-3.2-41.6 12.8-3.2 3.2-3.2 9.6-3.2 16z\" p-id=\"16450\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/warehouse.svg
// module id = HzdX
// module chunks = 7